import { render, staticRenderFns } from "./WidgetKpi.vue?vue&type=template&id=4c946b96&scoped=true&"
import script from "./WidgetKpi.vue?vue&type=script&lang=js&"
export * from "./WidgetKpi.vue?vue&type=script&lang=js&"
import style0 from "./WidgetKpi.vue?vue&type=style&index=0&id=4c946b96&prod&lang=scss&scoped=true&"
import style1 from "./WidgetKpi.vue?vue&type=style&index=1&id=4c946b96&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c946b96",
  null
  
)

export default component.exports